/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_Ingest_ErrorInputs */

const es_tools_dropbox_ingest_error = /** @type {(inputs: Tools_Dropbox_Ingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al ingestar archivos de Dropbox`)
};

const en_tools_dropbox_ingest_error = /** @type {(inputs: Tools_Dropbox_Ingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error ingesting Dropbox files`)
};

/**
* | output |
* | --- |
* | "Error ingesting Dropbox files" |
*
* @param {Tools_Dropbox_Ingest_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_ingest_error = /** @type {((inputs?: Tools_Dropbox_Ingest_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_Ingest_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_ingest_error(inputs)
	return en_tools_dropbox_ingest_error(inputs)
});
export { tools_dropbox_ingest_error as "tools.dropbox.ingest_error" }